// SEO tags in <head> that users never see: lang, canonical, hreflang, robots, JSON-LD.
// Called from router.afterEach, so the prerendered HTML gets them too.
export const SITE = 'https://bluuu.co'
const LOCALES = ['th', 'en']
const DEFAULT_LOCALE = 'th'
const MARK = 'data-seo-head'

// Public pages that exist in both languages
export const INDEXABLE = [
  'index',
  'Home',
  'Maids',
  'Pricing',
  'Faq',
  'AboutUs',
  'ContactUs',
  'BookingOneTime',
  'BookingMultiPackage',
  'Recruitment',
  'Terms',
  'PrivacyAndPolicy',
  'UserDataDeletionInstructions',
]

// Private or transactional pages: keep out of search results
export const NOINDEX = [
  'TimeOut',
  'Slip Confirm',
  'LineLogIn',
  'SelectMaid',
  'MyAccount',
  'ResetPassword',
  'PaymentMedthod',
  'PaymentResult',
  'History',
  'BookingReview',
  'VerifyPhone',
  'BookingConfirm',
  'MyBooking',
  'MyFavoriteMaid',
  'MyBookingOneTime',
  'MyBookingMultiPackage',
  'MyMultiPackage',
  'Welcome',
  'UnderConStruction',
  'Admin',
]

const withSlash = (p) => (p.endsWith('/') ? p : p + '/')

// '/th/pricing/' -> '/pricing/', '/' -> '/'
export const stripLocale = (path) => withSlash(path.replace(/^\/(th|en)(?=\/|$)/, '') || '/')

export const buildHead = (route, locale) => {
  const lang = LOCALES.includes(locale) ? locale : DEFAULT_LOCALE
  const head = { lang, links: [], metas: [], jsonld: null }
  const name = route && route.name

  if (NOINDEX.includes(name)) {
    head.metas.push({ name: 'robots', content: 'noindex, follow' })
    return head
  }
  if (!INDEXABLE.includes(name)) return head

  const rest = stripLocale(route.path || '/')
  const url = (l) => `${SITE}/${l}${rest}`
  head.links.push({ rel: 'canonical', href: url(lang) })
  LOCALES.forEach((l) => head.links.push({ rel: 'alternate', hreflang: l, href: url(l) }))
  head.links.push({ rel: 'alternate', hreflang: 'x-default', href: url(DEFAULT_LOCALE) })

  if (name === 'index' || name === 'Home') {
    head.jsonld = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          '@id': `${SITE}/#organization`,
          name: 'Bluuu',
          legalName: lang === 'th' ? 'บริษัท บลูเซอร์วิสเซส จำกัด' : 'Blue Services Co., Ltd.',
          url: `${SITE}/`,
          logo: `${SITE}/logo.jpeg`,
          email: 'info@bluuu.co',
          telephone: '+66-2-055-6768',
          address: {
            '@type': 'PostalAddress',
            streetAddress:
              lang === 'th'
                ? 'ชั้น 2 สาทรฮับ เลขที่ 4 ถนนนราธิวาสราชนครินทร์ แขวงยานนาวา'
                : '2F Sathorn Hub, 4 Naradhiwas Rajanagarindra Rd, Yannawa',
            addressLocality: lang === 'th' ? 'เขตสาทร' : 'Sathorn',
            addressRegion: lang === 'th' ? 'กรุงเทพมหานคร' : 'Bangkok',
            postalCode: '10120',
            addressCountry: 'TH',
          },
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'customer service',
            telephone: '+66-2-055-6768',
            email: 'info@bluuu.co',
            areaServed: 'TH',
            availableLanguage: ['th', 'en'],
          },
          sameAs: ['https://line.me/R/ti/p/@bluuu'],
        },
        {
          '@type': 'WebSite',
          '@id': `${SITE}/#website`,
          url: `${SITE}/`,
          name: 'Bluuu',
          inLanguage: lang,
          publisher: { '@id': `${SITE}/#organization` },
        },
      ],
    }
  }
  return head
}

export const applySeoHead = (route, locale, doc = document) => {
  try {
    const head = buildHead(route, locale)
    doc.documentElement.setAttribute('lang', head.lang)
    Array.from(doc.querySelectorAll(`[${MARK}]`)).forEach((el) => el.parentNode.removeChild(el))
    const add = (tagName, attrs, text) => {
      const el = doc.createElement(tagName)
      Object.keys(attrs).forEach((k) => el.setAttribute(k, attrs[k]))
      el.setAttribute(MARK, '')
      if (text) el.textContent = text
      doc.head.appendChild(el)
    }
    head.links.forEach((l) => add('link', l))
    head.metas.forEach((m) => add('meta', m))
    if (head.jsonld) add('script', { type: 'application/ld+json' }, JSON.stringify(head.jsonld))
  } catch (e) {
    // SEO tags must never break navigation
  }
}
